import React from 'react';

/**
 * @param {object} props
 * @return {*}
 * @constructor
 */
const Header = (props) => (
    <div className="px-4 py-2 bg-app-blue-dark">
        <div className={'md:flex md:items-center md:justify-between pt-3 md:pt-0 ' + (props.children ? '' : 'mb-4 md:mb-0')}>
            <div className="flex-1 min-w-0">
                <h2 className="text-2xl font-bold leading-7 text-white sm:leading-9 sm:truncate">
                    {props.header}
                </h2>
            </div>
            {props.children && (
                <div className="mt-4 md:flex grid grid-cols-3 gap-2 md:gap-0 md:mt-0 md:ml-4 mb-4 md:mb-0 space-x-2">
                    {props.children}
                </div>
            )}
        </div>
    </div>
);

export default Header;
